export const SKIN_TONES = ["#FFE0C2", "#F5C9A0", "#DBA46A", "#B57A4C", "#8C5730", "#5B3A22"];

export const HAIR_COLORS = [
  "#2B1B12", "#5C3A21", "#A0522D", "#E3A23F", "#F5D76E",
  "#C62828", "#3B82F6", "#A855F7", "#10B981", "#EC4899",
];

export const OUTFIT_COLORS = [
  "#F59E0B", "#EF4444", "#3B82F6", "#10B981",
  "#8B5CF6", "#EC4899", "#0EA5E9", "#1F2937",
];

export const LOOKS = [
  { id: "boy", name: "Boy", emoji: "👦" },
  { id: "girl", name: "Girl", emoji: "👧" },
];

export const HAIR_STYLES = [
  { id: "short", name: "Short" },
  { id: "sidepart", name: "Side Part" },
  { id: "buzz", name: "Buzz" },
  { id: "fade", name: "Flat Top" },
  { id: "spiky", name: "Spiky" },
  { id: "mohawk", name: "Mohawk" },
  { id: "curly", name: "Curly" },
  { id: "afro", name: "Afro" },
  { id: "long", name: "Long" },
  { id: "ponytail", name: "Ponytail" },
  { id: "pigtails", name: "Pigtails" },
  { id: "braids", name: "Braids" },
  { id: "bun", name: "Bun" },
];

export const OUTFITS = [
  { id: "tee", name: "T-Shirt" },
  { id: "hoodie", name: "Hoodie" },
  { id: "overalls", name: "Overalls" },
  { id: "apron", name: "Apron" },
  { id: "jersey", name: "Jersey" },
  { id: "dress", name: "Dress" },
];

export const ACCESSORIES = [
  { id: "none", name: "None" },
  { id: "glasses", name: "Glasses" },
  { id: "cap", name: "Cap" },
  { id: "headband", name: "Headband" },
  { id: "bow", name: "Bow" },
  { id: "bandana", name: "Bandana" },
  { id: "crown", name: "Crown" },
];

export const PETS = [
  { id: "dog", name: "Dog", defaultName: "Biscuit", cheers: ["Woof! Go go!", "You got this!", "Paw-some!"] },
  { id: "cat", name: "Cat", defaultName: "Mochi", cheers: ["Purr-fect!", "Meow-velous!", "Keep going!"] },
  { id: "bunny", name: "Bunny", defaultName: "Clover", cheers: ["Hop to it!", "So fast!", "Yay you!"] },
  { id: "hamster", name: "Hamster", defaultName: "Peanut", cheers: ["Squeak! Nice!", "Tiny but mighty!", "Go boss!"] },
  { id: "parrot", name: "Parrot", defaultName: "Kiwi", cheers: ["Profit! Profit!", "Nice work!", "Squawk-tastic!"] },
  { id: "turtle", name: "Turtle", defaultName: "Sheldon", cheers: ["Slow & steady!", "Nice one!", "Shell yeah!"] },
  { id: "lioncub", name: "Lion Cub", defaultName: "Simba", cheers: ["Roar! Nice!", "King of biz!", "Mane event!"] },
];

export const DEFAULT_AVATAR = {
  look: "boy",
  skin: 1,
  hairStyle: "short",
  hairColor: 0,
  outfit: "tee",
  outfitColor: 0,
  accessory: "none",
  pet: "dog",
  petName: "Biscuit",
};

const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];

export const randomAvatar = () => {
  const pet = pick(PETS);
  const look = pick(LOOKS).id;
  return {
    look,
    skin: Math.floor(Math.random() * SKIN_TONES.length),
    hairStyle: pick(look === "boy" ? HAIR_STYLES.slice(0, 8) : HAIR_STYLES.slice(6)).id,
    hairColor: Math.floor(Math.random() * HAIR_COLORS.length),
    outfit: pick(OUTFITS).id,
    outfitColor: Math.floor(Math.random() * OUTFIT_COLORS.length),
    accessory: pick(ACCESSORIES).id,
    pet: pet.id,
    petName: pet.defaultName,
  };
};

export const getPet = (id) => PETS.find((p) => p.id === id) || PETS[0];
